// extracted by mini-css-extract-plugin
export var contact = "t_K";
export var logo = "t_T";
export var mobile = "t_S";
export var root = "t_g";
export var transparent = "t_R";